/** A case's four narrative fields and its metrics, as a card, the anonymized preview and the share dialog show them. */

import { CASE_TEXT_FIELDS, type CaseMetric, type CaseTextKey } from '@/api/types/cases';
import { Markdown } from '@/ui/Markdown';

import { metricResult } from '../proof/proofText';
import { ProvenanceBadge } from './badges';

export type CaseContent = Record<CaseTextKey, string> & { metrics: CaseMetric[] };

export function CaseMetrics({ metrics, caption }: { metrics: CaseMetric[]; caption: string }) {
  if (metrics.length === 0) return <p className="hint">No metrics recorded.</p>;
  return (
    <div className="table-scroll">
      <table className="data zebra compact" aria-label={caption}>
        <thead>
          <tr>
            <th scope="col">Metric</th>
            <th scope="col">Result</th>
            <th scope="col">Provenance</th>
          </tr>
        </thead>
        <tbody>
          {metrics.map((m, i) => (
            <tr key={'id' in m ? m.id : `${m.label}-${i}`}>
              <th scope="row">{m.label}</th>
              <td>{metricResult(m)}</td>
              <td>
                <ProvenanceBadge provenance={m.provenance} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function CaseBody({ content, label }: { content: CaseContent; label: string }) {
  return (
    <>
      {CASE_TEXT_FIELDS.map(({ key, label: heading }) => (
        <div key={key} className="case-text">
          <h4>{heading}</h4>
          {content[key].trim() ? <Markdown headingLevel={4}>{content[key]}</Markdown> : <p className="hint">Not recorded</p>}
        </div>
      ))}
      <CaseMetrics metrics={content.metrics} caption={`Metrics of ${label}`} />
    </>
  );
}
